import { Routes, RouterModule } from '@angular/router';
import { AuthorRuleComponent } from './author-rule.component';

const routes: Routes = [
    {
        path: '',
        component: AuthorRuleComponent
    },
];

export const AuthorRuleRoutes = RouterModule.forChild(routes);
